/** Public, browser-safe configuration only (everything VITE_* ends up in the bundle). */
const env = import.meta.env

export const config = {
  supabaseUrl: (env.VITE_SUPABASE_URL as string | undefined) || null,
  supabaseKey: ((env.VITE_SUPABASE_PUBLISHABLE_KEY ?? env.VITE_SUPABASE_ANON_KEY) as string | undefined) || null,
  apiUrl: ((env.VITE_API_URL as string | undefined) || '').replace(/\/$/, '') || null,
  appEnv: ((env.VITE_APP_ENV as string | undefined) || 'demo') as 'local' | 'demo' | 'staging' | 'production',
}

/** Data is simulated in the browser until the API URL is configured. */
export const isMockData = () => !config.apiUrl
